const parameters = new URLSearchParams(window.location.search);

export const isPreview = process.env.REACT_APP_LOCAL_PREVIEW === 'true';
export const isDemo = isPreview && parameters.get('data') !== 'api';
export const isResponsive = parameters.get('design') !== 'classic';
export const isEmbedded = window.self !== window.top;

export function designLink(design: 'classic' | 'responsive') {
  const next = new URLSearchParams(window.location.search);
  next.set('design', design);
  return `?${next.toString()}`;
}
